const listeners = new Set<() => void>();

const state: {
  resizeObserver: ResizeObserver | null;
  scrollRoot: HTMLElement | null;
  stickyHeader: HTMLElement | null;
  stickyHeaderHeightPx: number;
} = {
  resizeObserver: null,
  scrollRoot: null,
  stickyHeader: null,
  stickyHeaderHeightPx: 0,
};

const notify = () => listeners.forEach((listener) => listener());

const measureStickyHeader = () => {
  const heightPx = state.stickyHeader
    ? Math.round(state.stickyHeader.getBoundingClientRect().height)
    : 0;

  if (heightPx === state.stickyHeaderHeightPx) {
    return;
  }

  state.stickyHeaderHeightPx = heightPx;
  notify();
};

export const setToothSliceScrollRoot = (node: HTMLElement | null) => {
  if (state.scrollRoot === node) {
    return;
  }

  state.scrollRoot = node;
  notify();
};

export const setToothSliceStickyHeader = (node: HTMLElement | null) => {
  if (state.stickyHeader === node) {
    return;
  }

  state.resizeObserver?.disconnect();
  state.resizeObserver = null;
  state.stickyHeader = node;

  measureStickyHeader();

  if (!node || typeof ResizeObserver === 'undefined') {
    return;
  }

  state.resizeObserver = new ResizeObserver(measureStickyHeader);
  state.resizeObserver.observe(node);
};

export const getToothSliceScrollRoot = () => state.scrollRoot;

export const getToothSliceStickyHeaderHeight = () => state.stickyHeaderHeightPx;

export const subscribeToToothSliceScrollRoot = (listener: () => void) => {
  listeners.add(listener);

  return () => listeners.delete(listener);
};
